import { type ImportColumnDescriptor } from '@utazzo/shared';

const IMPORTED_META_KEY = '__imported';

/** Legacy / optional columns hidden from preview when empty or redundant. */
const HIDE_WHEN_EMPTY = new Set([
  'firstName',
  'lastName',
  'adId',
  'adName',
  'email',
  'querySourceUrl',
  'requirementSummary',
  'notes',
  'createdByName',
  'adsetId',
  'adsetName',
  'campaignId',
  'campaignName',
  'formId',
  'formName',
  'preferredTravelMode',
  'expectedTravelStart',
  'expectedTravelEnd',
  'preferredHotelCategory',
  'bookingTimeline',
  'hasValidPassport',
  'isFlightBooked',
  'travellerChildren',
  'travellerInfants',
  'budgetAmount',
  'querySourceName',
  'queryMediumName',
]);

function cellValue(merged: Record<string, unknown>, field: string): string {
  const v = merged[field];
  if (v === null || v === undefined) return '';
  if (typeof v === 'object') return JSON.stringify(v);
  return String(v).trim();
}

export function stripImportMeta(row: Record<string, unknown>): Record<string, unknown> {
  const { [IMPORTED_META_KEY]: _drop, ...rest } = row;
  return rest;
}

export function importedSnapshot(row: Record<string, unknown>): Record<string, unknown> {
  const snap = row[IMPORTED_META_KEY];
  return snap && typeof snap === 'object' && !Array.isArray(snap)
    ? (snap as Record<string, unknown>)
    : {};
}

/**
 * Columns shown in the lead-import row preview. Hides legacy first/last
 * name when Customer Name is present, and drops optional empty fields
 * so operators see only what the sheet actually carried.
 */
export function leadImportPreviewColumns(
  columns: ReadonlyArray<ImportColumnDescriptor>,
  merged: Record<string, unknown>,
): ReadonlyArray<ImportColumnDescriptor> {
  const hasCustomerName = cellValue(merged, 'customerName').length > 0;
  return columns.filter((col) => {
    if (col.field === IMPORTED_META_KEY) return false;
    if (hasCustomerName && (col.field === 'firstName' || col.field === 'lastName')) {
      return false;
    }
    if (HIDE_WHEN_EMPTY.has(col.field) && cellValue(merged, col.field) === '') {
      return false;
    }
    return true;
  });
}
